import { render, staticRenderFns } from "./SearchSidebarFacet.vue?vue&type=template&id=73b185c5&"
import script from "./SearchSidebarFacet.vue?vue&type=script&lang=js&"
export * from "./SearchSidebarFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports